import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import { purple, green, red, blue, indigo, teal } from '@material-ui/core/colors';
import CustomButton from './CustomButton';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function NewsPaperReport() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            デーリー東北学生文芸大会
          </Typography>
          　デーリー東北新聞社では、「デーリー東北学生文芸大会」を開催します。今年、新型コロナウイルスの影響で文芸活動とその発表の機会を制限されてしまった子どもたちに、文芸に親しんでもらうことを目指します。<br/>
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            デーリー東北学生文芸大会 実施要項
          </Typography>
          <dl>
            <dt>対象</dt>
            <dd>
              青森県南、岩手県北地方の小学生と中高生
            </dd>
            <dt>題</dt>
            <dd>
              短歌「雲（くも）」<br />
              俳句「西瓜（すいか）」<br />
              川柳「笑顔（えがお）」<br />
            </dd>
            <dt>応募方法</dt>
            <dd>
              投稿はそれぞれ１人１作品まで。短歌、俳句、川柳のいずれかでも、三つ全ての投稿でも可。所定の投稿用紙に作品、氏名（ふりがな）、学校名、学年を記入し、学校ごとに応募する。個人応募の場合は、住所と電話番号も記入すること。<br />
              ※投稿用紙は、下記からダウンロードできます。
              <Box my={4} textAlign="center">
                <Grid className="p-3" spacing={0} container direction="row" justify="center">
                  <Grid item xs={12} md={4}>
                    <CustomButton href="/pdf/bunka/gakusei-bungei.pdf" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                      投稿用紙ダウンロード
                    </CustomButton>
                  </Grid>
                </Grid>
              </Box>
            </dd>
            <dt>締め切り</dt>
            <dd>
              ２０２０年８月３１日（月）必着
            </dd>
            <dt>選考</dt>
            <dd>
              ９月初旬に【小学校低学年】【小学校高学年】【中高生】の３部門に分けて選考を行い、１０月に紙面で結果を発表。表彰式は行いません。
            </dd>
            <dt>賞</dt>
            <dd>
              それぞれ上位３人に賞状。他にも秀逸、佳作あり。１位の児童、生徒にはインタビューも行います。
            </dd>
            <dt>応募・問い合わせ先</dt>
            <dd>
              〒０３１ー８６０１（住所不要）デーリー東北新聞社「デーリー東北学生文芸大会」係<br />
              電話：０１７８（４４）５１１１、平日午前１０時～午後５時<br />
              メール：<a href="mailto:bunka@daily-tohoku.co.jp">bunka@daily-tohoku.co.jp</a>
            </dd>
          </dl>
        </Box>
      </div>
    </div>
  );
}

export default NewsPaperReport;
